(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- FAQ ---------- */
  document.querySelectorAll('.faq__item').forEach(function (item) {
    var btn = item.querySelector('.faq__q');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var isOpen = item.classList.contains('is-open');
      item.classList.toggle('is-open', !isOpen);
      btn.setAttribute('aria-expanded', String(!isOpen));
    });
  });

  /* ---------- Contadores animados ---------- */
  var counters = document.querySelectorAll('[data-count-to]');
  if (counters.length) {
    var renderFinal = function (el) {
      var to = el.getAttribute('data-count-to');
      var suffix = el.getAttribute('data-count-suffix') || '';
      el.textContent = to + suffix;
    };
    if (reduced || !('IntersectionObserver' in window)) {
      counters.forEach(renderFinal);
    } else {
      var animateCount = function (el) {
        var target = parseFloat(el.getAttribute('data-count-to'));
        if (isNaN(target)) return;
        var suffix = el.getAttribute('data-count-suffix') || '';
        var decimals = el.getAttribute('data-count-decimals') ? parseInt(el.getAttribute('data-count-decimals'), 10) : 0;
        var duration = 1300;
        var start = null;
        var step = function (ts) {
          if (start === null) start = ts;
          var p = Math.min(1, (ts - start) / duration);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = (target * eased).toFixed(decimals) + suffix;
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      };
      var countObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            animateCount(entry.target);
            countObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.6 });
      counters.forEach(function (c) { countObserver.observe(c); });
    }
  }

  /* ---------- Barra fija de compra (producto) ---------- */
  var addBtn = document.querySelector('.product__add');
  var stickyBar = document.querySelector('[data-sticky-cta]');
  if (addBtn && stickyBar && 'IntersectionObserver' in window) {
    var stickyObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var pastButton = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyBar.classList.toggle('is-visible', pastButton);
        /* sube el botón de WhatsApp para que no quede tapado por la barra */
        document.body.classList.toggle('has-sticky-cta', pastButton);
      });
    }, { threshold: 0 });
    stickyObserver.observe(addBtn);
  }

  /* ---------- Pulso del contador del carrito ---------- */
  if (!reduced && 'MutationObserver' in window) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      var prev = el.textContent;
      var mo = new MutationObserver(function () {
        if (el.textContent !== prev) {
          prev = el.textContent;
          el.classList.remove('is-pulsing');
          void el.offsetWidth;
          el.classList.add('is-pulsing');
        }
      });
      mo.observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  /* ---------- Galería de producto: fundido, precarga y deslizar con el dedo ---------- */
  document.querySelectorAll('[data-gallery]').forEach(function (g) {
    var mainWrap = g.querySelector('[data-gallery-main]');
    if (!mainWrap) return;
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-gallery-thumb]'));

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        mainWrap.classList.add('is-fading');
        setTimeout(function () { mainWrap.classList.remove('is-fading'); }, 180);
      });
    });

    if (thumbs.length < 2) return;

    var preloaded = false;
    var preload = function () {
      if (preloaded) return;
      preloaded = true;
      thumbs.forEach(function (t) {
        var s = t.getAttribute('data-src');
        if (s) { var im = new Image(); im.src = s; }
      });
    };
    g.addEventListener('pointerdown', preload, { once: true, passive: true });

    var sx = 0, sy = 0, tracking = false;
    mainWrap.addEventListener('touchstart', function (e) {
      var t = e.touches[0];
      sx = t.clientX; sy = t.clientY; tracking = true;
    }, { passive: true });
    mainWrap.addEventListener('touchend', function (e) {
      if (!tracking) return;
      tracking = false;
      var t = e.changedTouches[0];
      var dx = t.clientX - sx, dy = t.clientY - sy;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
      var idx = 0;
      thumbs.forEach(function (th, i) { if (th.classList.contains('is-active')) idx = i; });
      var next = dx < 0 ? idx + 1 : idx - 1;
      if (next < 0 || next >= thumbs.length) return;
      thumbs[next].click();
      var strip = thumbs[next].parentElement;
      if (strip && strip.scrollTo && strip.scrollWidth > strip.clientWidth) {
        var sr = strip.getBoundingClientRect();
        var tr = thumbs[next].getBoundingClientRect();
        strip.scrollTo({ left: strip.scrollLeft + (tr.left - sr.left) - (sr.width - tr.width) / 2, behavior: reduced ? 'auto' : 'smooth' });
      }
    }, { passive: true });
  });

  /* ---------- Cantidad: nunca menos de 1 en producto ---------- */
  document.querySelectorAll('input[name="quantity"]').forEach(function (input) {
    input.addEventListener('blur', function () {
      var v = parseInt(input.value, 10);
      if (isNaN(v) || v < 1) input.value = 1;
    });
  });

  /* ---------- Producto: variantes, "Comprar ahora" y envío único ---------- */
  var productForm = document.querySelector('form[id^="product-form-"]');
  if (productForm) {
    var returnTo = productForm.querySelector('[data-return-to]');
    var buyButtons = document.querySelectorAll('[data-buy-now]');
    var addButtons = document.querySelectorAll('[data-add-btn]');

    var setReturn = function (value) { if (returnTo) returnTo.value = value; };
    buyButtons.forEach(function (b) { b.addEventListener('click', function () { setReturn('/checkout'); }); });
    addButtons.forEach(function (b) { b.addEventListener('click', function () { setReturn('/cart'); }); });

    /* evita pedidos duplicados si el cliente toca dos veces con internet lento */
    productForm.addEventListener('submit', function (e) {
      if (productForm.classList.contains('is-submitting')) { e.preventDefault(); return; }
      productForm.classList.add('is-submitting');
      document.body.classList.add('is-submitting');
    });
    window.addEventListener('pageshow', function () {
      productForm.classList.remove('is-submitting');
      document.body.classList.remove('is-submitting');
      setReturn('/cart');
    });

    var select = productForm.querySelector('[data-variant-select]');
    if (select) {
      var priceEl = document.querySelector('[data-price-current]');
      var compareEl = document.querySelector('[data-price-compare]');
      var badgeEl = document.querySelector('[data-price-badge]');
      var stickyPrice = document.querySelector('[data-sticky-price]');
      var mainImg = document.querySelector('[data-gallery-main] img');

      /* guarda el HTML original del botón "Comprar ahora" para restaurarlo si cambia de agotado a disponible */
      buyButtons.forEach(function (b) {
        if (!b.hasAttribute('data-sticky-buy') && !b.disabled) b.setAttribute('data-buy-html', b.innerHTML);
      });

      var applyVariant = function () {
        var opt = select.options[select.selectedIndex];
        if (!opt) return;
        var available = opt.getAttribute('data-available') === 'true';
        var price = opt.getAttribute('data-price');
        var compare = opt.getAttribute('data-compare');
        var priceCents = parseInt(opt.getAttribute('data-price-cents'), 10);
        var compareCents = parseInt(opt.getAttribute('data-compare-cents'), 10);

        if (priceEl && price) priceEl.textContent = price;
        if (stickyPrice && price) stickyPrice.textContent = price;
        var onSale = !!compare && !isNaN(compareCents) && compareCents > priceCents;
        if (compareEl) { compareEl.textContent = onSale ? compare : ''; compareEl.hidden = !onSale; }
        if (badgeEl) {
          badgeEl.hidden = !onSale;
          if (onSale) badgeEl.textContent = '-' + Math.round((compareCents - priceCents) * 100 / compareCents) + '%';
        }

        addButtons.forEach(function (b) { b.disabled = !available; b.textContent = available ? 'Agregar al carrito' : 'Agotado'; });
        buyButtons.forEach(function (b) {
          b.disabled = !available;
          if (b.hasAttribute('data-sticky-buy')) {
            b.textContent = available ? 'Comprar ahora' : 'Agotado';
          } else if (!available) {
            b.textContent = 'Agotado';
          } else if (b.getAttribute('data-buy-html')) {
            b.innerHTML = b.getAttribute('data-buy-html');
          }
        });

        var img = opt.getAttribute('data-image');
        if (img && mainImg) {
          mainImg.src = img;
          document.querySelectorAll('[data-gallery-thumb]').forEach(function (t) {
            t.classList.toggle('is-active', t.getAttribute('data-src') === img);
          });
        }

        if (window.history && history.replaceState) {
          try {
            var url = new URL(window.location.href);
            url.searchParams.set('variant', select.value);
            history.replaceState(null, '', url.toString());
          } catch (err) { /* nada */ }
        }
      };

      select.addEventListener('change', applyVariant);
    }
  }

  /* ---------- Menú móvil: posición correcta, accesibilidad y seguridad al volver atrás ---------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  var drawer = document.querySelector('[data-drawer]');
  var header = document.querySelector('[data-header]');
  if (menuToggle && drawer && header) {
    var syncDrawer = function () {
      var open = drawer.classList.contains('is-open');
      drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
      if ('inert' in drawer) drawer.inert = !open;
    };
    syncDrawer();
    if ('MutationObserver' in window) {
      new MutationObserver(syncDrawer).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    }
    /* el menú empieza justo debajo del encabezado (aunque la barra de anuncio esté visible) */
    menuToggle.addEventListener('click', function () {
      drawer.style.setProperty('--drawer-top', Math.max(0, Math.round(header.getBoundingClientRect().bottom)) + 'px');
    });
    window.addEventListener('pageshow', function (e) {
      if (e.persisted) {
        drawer.classList.remove('is-open');
        menuToggle.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
        syncDrawer();
      }
    });
  }

  /* ---------- Parallax suave del hero (solo escritorio con mouse) ---------- */
  if (!reduced && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    var heroVisual = document.querySelector('.hero__visual');
    var hero = heroVisual ? heroVisual.closest('.hero') : null;
    if (hero && heroVisual) {
      hero.addEventListener('mousemove', function (e) {
        var r = hero.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width - 0.5;
        var y = (e.clientY - r.top) / r.height - 0.5;
        heroVisual.style.transform = 'translate(' + (x * 10).toFixed(1) + 'px, ' + (y * 10).toFixed(1) + 'px)';
      });
      hero.addEventListener('mouseleave', function () {
        heroVisual.style.transform = '';
      });
    }
  }

  /* ---------- Puntos de paginación en carruseles (reseñas, testimonios) ---------- */
  document.querySelectorAll('[data-carousel-track]').forEach(function (track) {
    var wrap = track.parentElement;
    var dotsHost = wrap ? wrap.querySelector('[data-carousel-dots]') : null;
    var cards = Array.prototype.slice.call(track.children);
    if (!dotsHost || cards.length < 2) return;

    var dots = cards.map(function (card, i) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'carousel-dots__dot' + (i === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Ir a la reseña ' + (i + 1) + ' de ' + cards.length);
      dot.addEventListener('click', function () {
        /* desplaza solo el carrusel (no toda la página) */
        var tr = track.getBoundingClientRect();
        var cr = card.getBoundingClientRect();
        track.scrollTo({ left: track.scrollLeft + (cr.left - tr.left) - 4, behavior: reduced ? 'auto' : 'smooth' });
      });
      dotsHost.appendChild(dot);
      return dot;
    });

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.6) return;
          var idx = cards.indexOf(entry.target);
          if (idx < 0) return;
          dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        });
      }, { root: track, threshold: [0.6] });
      cards.forEach(function (c) { io.observe(c); });
    }
  });
})();
